import JoditEditor from "jodit-react";
import React, { useRef } from "react";

export interface RichTextEditorProps {
  value: string;
  onChange: (e: any) => void;
}

export const RichTextEditor = (props: RichTextEditorProps) => {
  const {
    value,
    onChange,
  } = props;

  const editor = useRef(null);

  const config = { readonly: false }; // All options: https://xdsoft.net/jodit/doc/

  return (
    <JoditEditor
      ref={editor}
      value={value}
      config={config}
      onBlur={onChange} // Use this option to update the content for performance reasons
    />
  );
};
